(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("cornerstone-math"));
	else if(typeof define === 'function' && define.amd)
		define("cornerstoneTools", ["cornerstone-math"], factory);
	else if(typeof exports === 'object')
		exports["cornerstoneTools"] = factory(require("cornerstone-math"));
	else
		root["cornerstoneTools"] = factory(root["cornerstoneMath"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_56__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition